module.exports = __webpack_public_path__ + "img/sk.b84444bf.svg";